module.exports = __webpack_public_path__ + "img/15.ca976fe3.png";